export default function Activities() {
    return (<>
        <p>Activities</p>
    </>);
}